/* LIMSË ANIMATIONS — FROM THE SAVANNAH KABAL */
(function(){
  'use strict';

  /* ── LOADER ── */
  window.addEventListener('load', function(){
    var l = document.getElementById('limse-loader');
    if(l) setTimeout(function(){ l.classList.add('done'); }, 2000);
  });

  /* ── CUSTOM CURSOR ── */
  var dot = document.querySelector('.limse-cursor');
  var ring = document.querySelector('.limse-cursor-ring');
  if(dot && ring && window.innerWidth > 768){
    var mx=0, my=0, rx=0, ry=0;
    document.addEventListener('mousemove', function(e){
      mx = e.clientX; my = e.clientY;
      dot.style.left = mx+'px'; dot.style.top = my+'px';
    });
    (function tick(){
      rx += (mx-rx)*.1; ry += (my-ry)*.1;
      ring.style.left = rx+'px'; ring.style.top = ry+'px';
      requestAnimationFrame(tick);
    })();
    /* Hover grow */
    document.querySelectorAll('a,button,[role="button"],.card,.card-wrapper').forEach(function(el){
      el.addEventListener('mouseenter', function(){
        dot.style.width = '10px'; dot.style.height = '10px';
        ring.style.width = '48px'; ring.style.height = '48px'; ring.style.borderColor = 'rgba(196,151,90,.3)';
      });
      el.addEventListener('mouseleave', function(){
        dot.style.width = '6px'; dot.style.height = '6px';
        ring.style.width = '28px'; ring.style.height = '28px'; ring.style.borderColor = 'rgba(184,53,53,.4)';
      });
    });
  }

  /* ── SCROLL REVEAL — Limsë sections ── */
  var limseEls = document.querySelectorAll('.limse-reveal');
  if(limseEls.length){
    var obs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){ e.target.classList.add('is-visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    limseEls.forEach(function(el){ obs.observe(el); });
  }

  /* ── SCROLL REVEAL — Dawn shopify-sections ── */
  document.querySelectorAll('.shopify-section').forEach(function(s){
    if(s.closest('.shopify-section-header') || s.closest('.shopify-section--header')) return;
    s.style.opacity = '0';
    s.style.transform = 'translateY(22px)';
    s.style.transition = 'opacity .75s ease, transform .75s ease';
    var sobs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){
          e.target.style.opacity = '1';
          e.target.style.transform = 'translateY(0)';
          sobs.unobserve(e.target);
        }
      });
    }, { threshold: 0.04 });
    sobs.observe(s);
  });

  /* ── HEADER SCROLL — transparent to solid ── */
  var hdrs = document.querySelectorAll('.header-wrapper');
  hdrs.forEach(function(hdr){
    var onScroll = function(){
      if(window.scrollY > 60){
        hdr.classList.add('scrolled-past-header');
      } else {
        hdr.classList.remove('scrolled-past-header');
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  });
  /* Also handle Dawn's sticky header class */
  var stickyHeader = document.querySelector('sticky-header');
  if(stickyHeader){
    var hw = stickyHeader.querySelector('.header-wrapper');
    if(hw){
      window.addEventListener('scroll', function(){
        hw.classList.toggle('scrolled-past-header', window.scrollY > 60);
      }, { passive: true });
    }
  }

  /* ── ARCHIVE DRAG ── */
  var track = document.getElementById('limse-archive-track');
  if(track){
    var isDrag=false, startX, scrollL;
    track.addEventListener('mousedown', function(e){
      isDrag=true; track.style.cursor='grabbing';
      startX=e.pageX-track.offsetLeft; scrollL=track.scrollLeft;
    });
    ['mouseleave','mouseup'].forEach(function(ev){
      track.addEventListener(ev, function(){ isDrag=false; track.style.cursor='grab'; });
    });
    track.addEventListener('mousemove', function(e){
      if(!isDrag) return; e.preventDefault();
      track.scrollLeft = scrollL - (e.pageX - track.offsetLeft - startX) * 1.5;
    });
  }

  /* ── SMOOTH SCROLL for hero CTA + SCROLL indicator ── */
  document.querySelectorAll('.limse-hero__cta[href^="#"],.limse-hero__scroll').forEach(function(el){
    el.addEventListener('click', function(e){
      e.preventDefault();
      /* Find the next sibling section after the hero */
      var hero = document.querySelector('.limse-hero');
      if(hero){
        var next = hero.closest('.shopify-section');
        if(next && next.nextElementSibling){
          next.nextElementSibling.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });
  });
  /* Make scroll indicator clickable */
  var scrollEl = document.querySelector('.limse-hero__scroll');
  if(scrollEl) scrollEl.style.cursor = 'pointer';

})();


/* ── PRODUCT GALLERY SWIPE ── */
(function(){
  var gallery = document.querySelector('.product__media-list');
  if(!gallery) return;
  var items = gallery.querySelectorAll('.product__media-item');
  if(items.length < 2) return;
  
  /* Create dot indicators */
  var dots = document.createElement('div');
  dots.style.cssText = 'display:flex;justify-content:center;gap:8px;padding:12px;';
  items.forEach(function(item, i){
    var dot = document.createElement('div');
    dot.style.cssText = 'width:8px;height:8px;border-radius:50%;border:1px solid rgba(255,255,255,.3);cursor:pointer;transition:all .3s;';
    if(i === 0) dot.style.background = '#c4975a';
    dot.addEventListener('click', function(){
      item.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    });
    dots.appendChild(dot);
  });
  gallery.parentNode.insertBefore(dots, gallery.nextSibling);
  
  /* Update dots on scroll */
  var observer = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){
        var idx = Array.from(items).indexOf(e.target);
        dots.querySelectorAll('div').forEach(function(d, i){
          d.style.background = i === idx ? '#c4975a' : 'transparent';
          d.style.borderColor = i === idx ? '#c4975a' : 'rgba(255,255,255,.3)';
        });
      }
    });
  }, { root: gallery, threshold: 0.6 });
  items.forEach(function(item){ observer.observe(item); });
})();
